import { camelCase } from "lodash-es";
import { useApi } from "./useApi";
import { FeaturesDto } from "../types";
import { CustomUseQueryOptions } from "./useApiWithClient";

type FlipperFeatures = {
  allStatesAvailable: boolean;
  askForAdditionalUserInfo: boolean;
  assetAssignmentActive: boolean;
  assetAssignmentRestriction: boolean;
  automaticEventCreator: boolean;
  basicAuthLayoff: boolean;
  connectQuotaCheck: boolean;
  customFermentationClient: boolean;
  demoDataActive: boolean;
  disableClientApplicationQuotaRefresh: boolean;
  edgeDeviceCreateNni: boolean;
  edgeDeviceEditPermissions: boolean;
  edgeDeviceLateBinding: boolean;
  edgeDeviceModbusEdit: boolean;
  eloqua: boolean;
  enterprisePlansActive: boolean;
  firmwareManagerActive: boolean;
  forecastBeta: boolean;
  googleTagManager: boolean;
  hidePlausibility: boolean;
  influxDataDisabled: boolean;
  isDeviceViewerEnabled: boolean;
  isVerifyActive: boolean;
  loginWithMyEndressHauser: boolean;
  manageMfa: boolean;
  mqttNextActive: boolean;
  mqttShutdownCloudmqtt: boolean;
  oneSubscription: boolean;
  recipeBatchAvailable: boolean;
  renderCloudStatus: boolean;
  requestUpgradeViaSalesforce: boolean;
  showAssetConfigurationButton: boolean;
  showClaimAsset: boolean;
  showAasDownloadLink: boolean;
  showAssetsViewButton: boolean;
  showGridViewButton: boolean;
  showTermsVersion2025: boolean;
  showTimeline: boolean;
  smartDestroyAssetValues: boolean;
  tagAutomaticallyCreated: boolean;
  timeseriesDataBenchmark: boolean;
  timeseriesDataEnabled: boolean;
  treePermissions: boolean;
  treePermissionsRefresh: boolean;
  isDeviceViewerDownloadAllEnabled: boolean;
  isDeviceViewerDownloadByLanguageEnabled: boolean;
  isDeviceViewerDownloadByCategoryEnabled: boolean;
  showNewNetilionPreview: boolean;
};

export const useFlipperQuery = (
  options?: CustomUseQueryOptions<FeaturesDto, FlipperFeatures>,
) => {
  const api = useApi();

  return api.get.useQuery<FeaturesDto, FlipperFeatures>(
    "/../flipper/api/features",
    null,
    {
      cacheTime: Infinity,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      select: (data) =>
        data.features.reduce((features, feature) => {
          const newFeatures = { ...features };
          newFeatures[camelCase(feature.key) as keyof FlipperFeatures] =
            feature.state === "on";
          return newFeatures;
        }, {} as FlipperFeatures),
      ...options,
    },
  );
};
